import React, { useState } from "react";
import { AddOrEditModal, CheckboxField } from "@wexinc/wex-ui";
import { UserFromAPI } from "services/users";
import { CopPermissionIds, CopPermissions, useCopSecurityService, useRoleService } from "services/security";

interface Props {
  onSaveRoles: (userId: string, roleIds: string[]) => void;
  onCancel: () => void;
  user: UserFromAPI;
}

interface FormValues {
  [key: string]: boolean;
}

const EditGlobalRolesModal: React.FC<Props> = (props) => {
  const { user, onCancel, onSaveRoles } = props;

  const [isSaving, setIsSaving] = useState(false);

  const copSecurityService = useCopSecurityService();
  const roleService = useRoleService();
  const globalRoles = roleService.roleStore.roles.filter((role) => role.allowGlobal);

  const defaultValues = user.globalRoles.reduce((acc, curr) => {
    return {
      ...acc,
      [curr.id]: true,
    };
  }, {});

  function canEditRole(permRequired?: string) {
    if (!permRequired) {
      return copSecurityService.userHasGlobalPermission("editRoles");
    }
    const permId = Object.entries(CopPermissions).find((e) => e[1] === permRequired);
    if (permId) {
      return copSecurityService.userHasGlobalPermission(permId[0] as CopPermissionIds);
    } else return false;
  }

  async function onSubmit(formValues: FormValues) {
    setIsSaving(true);
    const globalRoleIds = Object.entries(formValues)
      .filter((entry) => entry[1] === true)
      .map((entry) => entry[0]);
    await onSaveRoles(user.id, globalRoleIds);
    setIsSaving(false);
  }
  return (
    <AddOrEditModal
      formProps={{
        onSubmit,
        options: {
          defaultValues,
        },
      }}
      titleOrHeader={`Edit Global Roles: ${user.firstName} ${user.lastName}`}
      showRequiredLegend={false}
      onCancel={onCancel}
      okButtonDisabled={isSaving}
      okButtonText={isSaving ? "Saving..." : "Save"}
    >
      {globalRoles.map((r) => (
        <CheckboxField
          key={r.id}
          name={r.id}
          label={r.name}
          containerClassName="w-full pb-4"
          disabled={!canEditRole(r.globalPermissionRequiredToEdit)}
        />
      ))}
    </AddOrEditModal>
  );
};

export default EditGlobalRolesModal;
